const Footer = () => {
    return (
        <>
        <br /><br />
        <div className="Footer foot Footer-dark bg-dark p-2">
            <h4 className="text-white text-center">Copyright &copy; Martian .Inc 2022</h4>
        </div>
        </>
    )
}

export default Footer